import { Tags } from "../constants/tags.enum";
import { isNumber } from "./typeChecks.utils";
export var SupportGroupUserGroupTypeDefs = [
    {
        value: '12-14',
        name: 'Young People 12–14',
        abbr: 'YP 12–14',
        color: 'yellow',
        clientColor: 'pastelTeal',
    },
    {
        value: '15-17',
        name: 'Young People 15–17',
        abbr: 'YP 15–17',
        color: 'orange',
        clientColor: 'pastelPurple',
    },
    {
        value: '18+',
        name: 'Adults',
        abbr: 'Adults',
        color: 'brightPurple',
        clientColor: 'pastelGold',
    },
    // {
    //   value: Tags.FrontLineWorkers,
    //   name: 'Front Line Workers',
    //   abbr: 'Frontline',
    //   color: 'lightBlue',
    // },
];
export var ExtendedSupportGroupUserGroupTypeDefs = SupportGroupUserGroupTypeDefs.concat([
    {
        value: Tags.YoungPeoples,
        name: 'Young Peoples 12-17',
        abbr: 'YPs 12-17',
        color: 'orange',
    },
    // {
    //   value: Tags.AdultAnd1214,
    //   name: 'Adults and Young People 12-14',
    //   abbr: 'Adults, YP 12-14',
    //   color: 'yellow',
    // },
    // {
    //   value: Tags.AdultAnd1517,
    //   name: 'Adults and Young People 15-17',
    //   abbr: 'Adults, YP 15-17',
    //   color: 'orange',
    // },
    // {
    //   value: Tags.AdultsAndYoungPeople,
    //   name: 'Adults and Young People 12-17',
    //   abbr: 'Adults, YP 12-14, YP 15-17',
    //   color: 'brightPurple',
    // },
    // {
    //   value: Tags.NA,
    //   name: 'N/A',
    //   abbr: 'N/A',
    //   color: 'steel',
    // },
    {
        value: Tags.Unknown,
        name: 'Unknown',
        abbr: 'Unknown',
        color: 'brown',
    },
]);
export function makeSupportGroupViewerId(id) {
    return "support-group-viewer-" + (id || 'unknown');
}
export function supportGroupHasAvailability(sg) {
    var _a = sg || {}, reservationCount = _a.reservationCount, maxParticipants = _a.maxParticipants;
    return isNumber(reservationCount) && isNumber(maxParticipants) && (maxParticipants > reservationCount);
}
